import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SignalTranslation from './SignalTranslation';
import {
  getSignalTranslation,
  getUserProfileWidget,
  getCurrentTimezone,
  getDevicesUnitComponentParts,
  getDevicesUnitSubComponent,
  getSelectedUnit
} from '../../selectors/index';
import {
  describeSignalTranslationThunk,
  setSignalTranslationChangeThunk,
  setSignalTranslationResultChangeThunk,
  describeSignalTranslationEquationThunk,
  setSignalTranslationConstantThunk,
  saveSignalTranslationThunk,
  saveSignalTranslationCommentThunk
} from '../../actions/signalTranslation';
import { getUnitComponentPartsThunk } from '../../actions/devices';

const mapStateToProps = state => {
  return {
    signalTranslationManager: getSignalTranslation(state),
    userProfileWidgets: getUserProfileWidget(state),
    currentTimezone: getCurrentTimezone(state),
    unitComponentParts: getDevicesUnitComponentParts(state),
    unitSubComponentDetails: getDevicesUnitSubComponent(state),
    selectedUnit: getSelectedUnit(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setSignalTranslationChange: signalTranslation => setSignalTranslationChangeThunk(signalTranslation),
      setSignalTranslationResultChange: signalTranslationResults => setSignalTranslationResultChangeThunk(signalTranslationResults),
      describeSignalTranslation: (signalTranslationId, unitSerialNumber) =>
        describeSignalTranslationThunk(signalTranslationId, unitSerialNumber, 'SIGNALTRANSLATION_EDIT'),
      describeSignalTranslationEquation: (signalTranslationEquationId, signalTranslationId, modelCategoryId) =>
        describeSignalTranslationEquationThunk(signalTranslationEquationId, signalTranslationId, modelCategoryId, 'SIGNALTRANSLATION_ADD'),
      setSignalTranslationConstant: signalTranslationCompConstants => setSignalTranslationConstantThunk(signalTranslationCompConstants),
      getUnitComponentParts: (unitSerialNumber, unitId) => getUnitComponentPartsThunk(unitSerialNumber, unitId, 'SIGNALTRANSLATION_ADD'),
      saveSignalTranslation: (signalTranslation, unitSerialNumber, isOpSuccessful, widgetCode) =>
        saveSignalTranslationThunk(signalTranslation, unitSerialNumber, isOpSuccessful, widgetCode),
      saveSignalTranslationComment: (signalTranslation, unitSerialNumber, widgetCode) =>
        saveSignalTranslationCommentThunk(signalTranslation, unitSerialNumber, widgetCode)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SignalTranslation);
